export default "__VITE_ASSET__DSjSSSDc__"